import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from 'rebass';
import { display } from 'styled-system';

import SideMenuView from './SideMenu.view';

const ResponsiveBox = styled(Box)`
  ${display};
`;

class SideMenu extends Component {
  render() {
    const { items, isSideMenuOpen, toggleSideMenu, isLogin, myProfile, logout } = this.props;
    return (
      <Fragment>
        <ResponsiveBox display={['block', null, null, 'none']}>
          <SideMenuView
            items={items}
            position={'left'}
            open={isSideMenuOpen}
            onClose={toggleSideMenu}
            onLogout={logout}
            isLogin={isLogin}
            userProfile={myProfile}
            type={'temporary'}
          />
        </ResponsiveBox>
        <ResponsiveBox display={['none', null, null, 'block']}>
          <SideMenuView items={items} type={'permanent'} />
        </ResponsiveBox>
      </Fragment>
    );
  }
}

SideMenu.propTypes = {
  items: PropTypes.array,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  myProfile: PropTypes.object,
};

export default SideMenu;
